module.exports = __webpack_public_path__ + "img/sup_withdraw_crypto4.cf380856.jpg";